export const USER_AUTH_TOKEN = 'token';
export const USER_ROLE = 'role';
export const USER_WEB_SOCKET_CODE = '';

